import React, { useEffect, useRef, useState } from "react";
import SchedulerCommonSlice from "../../redux/slices/SchedulerCommonSlice";

export default function useTooltip(ref: any, tooltipText?: any) {
  const [tooltip, setTooltip] = useState<any>({
    domRect: "",
    text: "",
  });
  const [refLength, setRefLength] = useState<number>(0);
  const [initialValue, setInitialValue] = useState<number>(0);

  function onMouseOver(el: any, text?: string) {
    setTooltip({
      domRect: el?.getBoundingClientRect(),
      text: text ? text : "",
    });
  }
  function onMouseLeave() {
    setTooltip({ domRect: "", text: "" });
  }
  function getRefLength() {
    let counter = 0;
    return function increment() {
      counter++;
      return counter;
    };
  }
  const add = getRefLength();

  useEffect(() => {
    if (ref?.current?.length) {
      setRefLength(
        ref?.current?.reduce((prev: any, current: any) => {
          if (current) {
            return prev + 1;
          }
        }, initialValue)
      );
    }
  });

  useEffect(() => {
    addListenerOnMouseOver(ref, tooltipText, onMouseOver);
    addListenerOnMouseLeave(ref, onMouseLeave);
    return () => {
      removeListenerOnMouseOver(ref, tooltipText, onMouseOver);
      removeListenerOnMouseLeave(ref, onMouseLeave);
    };
  }, [refLength, tooltipText, ref.current]);

  return tooltip;
}

export function addListenerOnMouseOver(
  ref: any,
  tooltipTextRef: any,
  onMouseOver: any
) {
  if (!ref?.current) return;
  const list = Array.isArray(ref.current) ? ref.current : [ref.current];
  list.forEach((el: any, i: number) => {
    if (!el) return;
    const handler = () => {
      const source = tooltipTextRef?.current != null ? tooltipTextRef.current : tooltipTextRef;
      const text = source != null
        ? (Array.isArray(source) ? source[i] : source)
        : undefined;
      onMouseOver(el, text);
    };
    (el as any)._tooltipMouseOver = handler;
    el.addEventListener("mouseover", handler);
  });
}

export function removeListenerOnMouseOver(
  ref: any,
  tooltipTextRef: any,
  onMouseOver: any
) {
  if (!ref?.current) return;
  const list = Array.isArray(ref.current) ? ref.current : [ref.current];
  list.forEach((el: any) => {
    if (!el || !(el as any)._tooltipMouseOver) return;
    el.removeEventListener("mouseover", (el as any)._tooltipMouseOver);
    delete (el as any)._tooltipMouseOver;
  });
}

export function addListenerOnMouseLeave(ref: any, onMouseLeave: any) {
  if (!ref?.current) return;
  const list = Array.isArray(ref.current) ? ref.current : [ref.current];
  list.forEach((el: any) => {
    if (!el) return;
    (el as any)._tooltipMouseLeave = onMouseLeave;
    el.addEventListener("mouseleave", onMouseLeave);
  });
}

export function removeListenerOnMouseLeave(ref: any, onMouseLeave: any) {
  if (!ref?.current) return;
  const list = Array.isArray(ref.current) ? ref.current : [ref.current];
  list.forEach((el: any) => {
    if (!el || !(el as any)._tooltipMouseLeave) return;
    el.removeEventListener("mouseleave", (el as any)._tooltipMouseLeave);
    delete (el as any)._tooltipMouseLeave;
  });
}
